var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagGermany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 90,
    viewBox: "0 0 150 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4384_23979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 0H0V90H150V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 30H0V90H150V30Z",
    fill: "#DD0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 60H0V90H150V60Z",
    fill: "#FFCE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4384_23979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGermany);
export default __webpack_public_path__ + "static/media/flag_germany.f45a393b92a7d3e03ec15b26aafeb82f.svg";
export { ForwardRef as ReactComponent };